import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import { Form } from "react-bootstrap";
import { handleResponse } from "../../../APIHelpers/Responses";
const UpdateLibraryFile = ({
  show,
  title,
  bounds,
  submit,
  setShow,
  onStart,
  disabled,
  onMouseOut,
  draggleRef,
  onMouseOver,
  libraryFileData,
  setLibraryFileList,
}) => {
  const [description, setDescription] = useState("");
  const [libraryFileName, setLibraryFileName] = useState("");

  const updateLibraryFile = () => {
    let newArray = JSON.parse(localStorage.getItem("libraryFileList"));

    let findData = newArray?.find(
      (item) => item.fileId === libraryFileData?.fileId
    );
    let result = newArray?.filter(
      (item) => !(item.fileId === libraryFileData?.fileId)
    );

    let userData = {};
    userData.fileId = libraryFileData?.fileId;
    userData.libraryId = findData?.libraryId;
    userData.fileName = libraryFileName;
    userData.description = description;
    userData.createdAt = findData?.createdAt;
    userData.updatedAt = new Date();
    userData.noofrow = findData?.noofrow;
    userData.noofcolumn = findData?.noofcolumn;
    userData.data = findData?.data;
    userData.column = findData?.column;
    result.push(userData);
    result.sort((a, b) => a.createdAt - b.createdAt);

    let checkData = newArray.find((item) => item.name === libraryFileName);
    if (checkData) {
      let Message = {
        statusCode: 400,
        customMessage: "Opps! File Name Already Exist.",
      };
      handleResponse(Message);
      clearInputData();
    } else {
      localStorage.setItem("libraryFileList", JSON.stringify(result));
      let finalResult = result?.filter(
        (item) => item.libraryId === libraryFileData.libraryId
      );
      setLibraryFileList(finalResult);
      let Message = {
        statusCode: 200,
        customMessage: "File has been Successfully Updated.",
      };
      handleResponse(Message);
      clearInputData();
    }
  };

  const clearInputData = () => {
    setShow(!show);
  };

  const [error, setError] = useState("");
  const validateFileTitle = (input) => {
    const fileTitleRegex = /^[a-zA-Z0-9_]+$/;

    if (!fileTitleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  useEffect(() => {
    setLibraryFileName(libraryFileData?.fileName);
    setDescription(libraryFileData?.description);
  }, [libraryFileData]);

  return (
    <>
      <Modal
        title={
          <div
            className="modal_Heading"
            onMouseOver={() => {
              if (disabled) {
                onMouseOver();
              }
            }}
            onMouseOut={onMouseOut}
          >
            <h5>{title}</h5>
          </div>
        }
        width={400}
        open={show}
        onOk={() => setShow(!show)}
        onCancel={clearInputData}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <div className="common_css">
          <Form.Label>
            File Name<span>*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            placeholder="Enter File Name"
            autoFocus
            value={libraryFileName}
            onChange={(e) => {
              setLibraryFileName(e.target.value);
              validateFileTitle(e.target.value);
            }}
          />
          {error && (
            <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
              Folder Name Title should only contain capital letters, small
              letters, underScore, and numbers "Space Not Allowed"
              <br />
            </span>
          )}
          <Form.Label className="mt-3">
            Description<span>*</span>
          </Form.Label>
          <Form.Control
            className="mb-3"
            required
            as="textarea"
            placeholder="Enter File Description"
            autoFocus
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className="button_type footer_btn text-end px-3 pt-2">
          <button
            onClick={updateLibraryFile}
            disabled={!libraryFileName || !description || error}
          >
            {submit}
          </button>
        </div>
      </Modal>
    </>
  );
};
export default UpdateLibraryFile;
